import React from 'react'

export const Footer = () => {
  return (
    <div
      style={{
        paddingTop: '30px',
      }}
    ></div>
  )
}

export default Footer
